// sessionManager.ts
import store from "../core/data/redux/store";

import { setSessionExpired } from "../core/data/redux/sessionSlice";
import { setLogout } from "../core/data/redux/authSlice";

export let sessionHandlingInProgress = false;

const controllers = new Set<AbortController>();

/**
 * Ajouter un controller
 */
export const registerController = (controller: AbortController) => {
  controllers.add(controller);
};

/**
 * Retirer un controller
 */
export const unregisterController = (controller: AbortController) => {
  controllers.delete(controller);
};

/**
 * Annuler toutes les requêtes
 */
export const abortAllRequests = () => {
  controllers.forEach((controller) => controller.abort());
  controllers.clear();
};

/**
 * Déclencher expiration session
 */
export const triggerSessionExpired = (
  message = "Votre session a expiré. Veuillez vous reconnecter.",
  code = "default",
) => {
  // éviter plusieurs déclenchements
  if (sessionHandlingInProgress) return;
  // console.log("SESSION EXPIREE DETECTEE");

  sessionHandlingInProgress = true;

  // stop toutes les requêtes
  abortAllRequests();

  // forcer la déconnexion
  store.dispatch(setLogout());

  // ouvrir le modal redux
  store.dispatch(setSessionExpired({ message, code }));
};

// Réinitialiser l'état
export const resetSessionHandling = () => {
  sessionHandlingInProgress = false;
};
